import { Box, Flex } from "rebass";

import useQueryReady from "~/hooks/useQueryReady";
import { Card, AccessibleSelect } from "~/components";
import { useDepartementsOptions } from "~/utils/departements";

import { BoxStyle } from "./style";

const USER_TYPE_OPTIONS = [
  { label: "Tous les types", value: null },
  { label: "Mandataire individuel", value: "individuel" },
  { label: "Mandataire préposé d'établissement", value: "prepose" },
  { label: "Service", value: "service" },
];

export const ENQUETE_REPONSE_STATUS_OPTIONS = [
  { label: "Tous les status", value: null },
  { label: "En cours", value: "draft" },
  { label: "Réponse reçue", value: "submitted" },
  { label: "Réponse validée", value: "validated" },
];
const departementsOptionsConfig = {
  nullOption: {
    label: "Tous les départements",
  },
};
function DirectionEnqueteReponsesCriteria({ criteria, updateCriteria }) {
  const { departementsOptions, error, loading } = useDepartementsOptions(
    departementsOptionsConfig
  );

  if (!useQueryReady(loading, error)) {
    return null;
  }

  return (
    <Card>
      <Flex flexDirection="row">
        <Box sx={BoxStyle}>
          <AccessibleSelect
            instanceId={"departement-filter"}
            size="small"
            options={departementsOptions}
            placeholder={"Département"}
            value={criteria.selectedDepartement}
            onChange={(option) => updateCriteria("selectedDepartement", option)}
          />
        </Box>
        <Box sx={BoxStyle}>
          <AccessibleSelect
            instanceId={"user-type-filter"}
            size="small"
            options={USER_TYPE_OPTIONS}
            placeholder={"Type"}
            value={criteria.userType}
            onChange={(option) => updateCriteria("userType", option)}
          />
        </Box>
        <Box sx={BoxStyle}>
          <AccessibleSelect
            instanceId={"enquete-reponse-statut-filter"}
            size="small"
            options={ENQUETE_REPONSE_STATUS_OPTIONS}
            placeholder={"Statut"}
            value={criteria.responseStatus}
            onChange={(option) => updateCriteria("responseStatus", option)}
          />
        </Box>
      </Flex>
    </Card>
  );
}

export { DirectionEnqueteReponsesCriteria };
